import React, { useEffect, useMemo, useState } from 'react';
import { TableHeader } from '../../../components/TableElements/tableHeader';
import { Box, Button, Flex, Grid, Select, Table, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import { containerMaxWXl } from 'src/components/ContentContainer/contentContainer';
import { useMoralisQuery } from 'react-moralis';
import { Game } from '../../Games/Game/game';
import { CarouselControls } from '../../../components/CarouselControls/carouselControls';
import Moralis from 'moralis-v1';
import { t } from 'i18next';
import usePaginationController from '../../../providers/PaginationController/usePaginationController';
import { IGame } from 'src/providers/Games/useGames';
import { GamesState } from '../../Games/games';
import { GameLoader } from 'src/components/GameLoader/gameLoader';
import { GameListItem } from 'src/pages/Games/Game/gameListItem';

export const Spotlight = () => {
	const [state, handleState] = useState(GamesState.LOADING);
	const [games, setGames] = useState<IGame[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	const [gameTypes, setGameTypes] = useState<any[]>([]);
	const [selectedType, setSelectedType] = useState<string>('');
	const [filteredGames, setFilteredGames] = useState<any[]>([]);

	const handleGenreChange = (e: any) => {
		setSelectedType(e);
		if (e === 'all') setFilteredGames(games);
		else {
			const filteredGames = games.filter((game: any) => game.platforms.includes(e));
			console.log(filteredGames);
			setFilteredGames(filteredGames);
		}
	};

	const {
		currentPage,
		advancePage,
		recedePage,
		elementsTotal: gamesTotal,
		initElementsTotal: initGamesTotal,
		elementsPerPage,
	} = usePaginationController(20);

	/** *Spring sale* data */
	const {
		data: queryData,
		isLoading: isQueryDataLoading,
		isFetching: isQueryDataFetching,
	} = useMoralisQuery('Games', query => query.equalTo('listed', true).descending('updatedAt'), [currentPage]);

	/** *Spring sale* dataset size; fetched last */
	useEffect(() => {
		if (!isLoading) {
			(async () => {
				const query = new Moralis.Query('Games').equalTo('listed', true);

				const queryTotal = await query.count();
				initGamesTotal(queryTotal);
			})();
		}
	}, [isLoading]);

	const gameList = useMemo(
		() => (
			<Table
				width={{ base: '100%', md: containerMaxWXl }}
				overflowX="auto"
				maxWidth={{ base: '90vw', xl: containerMaxWXl }}
			>
				<Thead>
					<Tr maxW={{ base: '90vw', xl: containerMaxWXl }}>
						<Th>#</Th>
						<Th>Name</Th>
						<Th>Category</Th>
						<Th>Type</Th>
						<Th>Fee</Th>
						<Th>Supply</Th>
						<Th>Price</Th>
					</Tr>
				</Thead>
				<Tbody
					maxWidth={{ base: '90vw', xl: containerMaxWXl }}
					overflowX="auto"
				>
					{filteredGames.map((game: IGame, index: number) => (
						<GameListItem
							key={game.address}
							data={game}
							index={index}
						/>
					))}
				</Tbody>
			</Table>
		),
		[filteredGames, games]
	);

	const typeOptions: { [p: number]: () => React.ReactNode } = {
		[GamesState.LOADING]: () => (
			<Flex
				position="absolute"
				height="250px"
				width="100%"
				justifyContent="space-between"
				alignItems="center"
				borderRadius="6px"
			>
				{Array.from(Array(6).keys()).map(id => {
					return <GameLoader key={id} />;
				})}
			</Flex>
		),
		[GamesState.FETCHED]: () => gameList,
	};

	const connectType = useMemo(() => {
		if (state === GamesState.LOADING) {
			return GamesState.LOADING;
		}
		if (state === GamesState.FETCHED) {
			return GamesState.FETCHED;
		}
		return GamesState.LOADING;
	}, [state]);

	useEffect(
		() => setIsLoading(isQueryDataLoading || !queryData.length || isQueryDataFetching),
		[queryData, isQueryDataLoading, isQueryDataFetching]
	);

	useEffect(() => {
		if (isLoading) {
			setGames([]);
			setFilteredGames([]);

			handleState(GamesState.LOADING);
		} else {
			const payload = (queryData as any).map((entity: any) => entity.attributes) as IGame[];
			setGames(payload);
			setFilteredGames(payload);
			var gameTypes: any[] = [];
			payload.forEach((entity: any) => {
				entity.genres.forEach((genre: string) => {
					if (gameTypes.indexOf(genre.toUpperCase()) < 0) gameTypes.push(genre.toUpperCase());
				});
			});

			console.log(gameTypes);
			setGameTypes(gameTypes);
			console.log(payload);

			handleState(GamesState.FETCHED);
		}
	}, [isLoading]);

	return (
		<Flex
			width="100%"
			maxWidth={containerMaxWXl}
			flexDirection="column"
			padding={{ base: '0 20px', hashup: 0 }}
			gridGap="16px"
		>
			<Flex
				width="100%"
				alignItems="center"
			>
				<TableHeader
					isLoadMore={false}
					onClickRightHeader={() => null as unknown as void}
					loading={false}
					header={t('home.trending').toString()}
					headerRightText=""
					headerStyle={{ width: 'auto' }}
				/>
				<CarouselControls
					onAdvance={advancePage}
					onRecede={recedePage}
					elements={{ total: gamesTotal, currentPage, perPage: elementsPerPage }}
				/>
				<Flex
					gap="8px"
					overflow={{ base: 'auto', md: 'unset' }}
					maxW="50vw"
				>
					<Button
						_hover={{ bg: '#ff3f3f', opacity: '0.7' }}
						onClick={() => handleGenreChange('all')}
						bgColor="none"
						bg={selectedType === 'all' ? '#ff3f3f' : 'none'}
						border="1px solid #ff3f3f"
						minW="50px"
					>
						All
					</Button>
					<Button
						_hover={{ bg: '#ff3f3f', opacity: '0.7' }}
						onClick={() => handleGenreChange('software-key')}
						bgColor="none"
						bg={selectedType === 'software-key' ? '#ff3f3f' : 'none'}
						border="1px solid #ff3f3f"
						minW="120px"
					>
						Software key
					</Button>
					<Button
						_hover={{ bg: '#ff3f3f', opacity: '0.7' }}
						onClick={() => handleGenreChange('ticket')}
						bgColor="none"
						bg={selectedType === 'ticket' ? '#ff3f3f' : 'none'}
						border="1px solid #ff3f3f"
						minW="80px"
					>
						Ticket
					</Button>
					<Button
						_hover={{ bg: '#ff3f3f', opacity: '0.7' }}
						onClick={() => handleGenreChange('web3')}
						bgColor="none"
						bg={selectedType === 'web3' ? '#ff3f3f' : 'none'}
						border="1px solid #ff3f3f"
						minW="70px"
					>
						Web3
					</Button>
				</Flex>
			</Flex>
			<Grid
				justifyContent="start"
				overflowX="scroll"
				position="relative"
				css={{
					'&::-webkit-scrollbar': {
						width: '0 !important',
					},
					//overflow: '-moz-scrollbars-none',
					//msOverflowStyle: 'none',
				}}
			>
				<Flex
					flexWrap={{ base: 'nowrap', xl: 'wrap' }}
					width={{ base: 'unset', xl: '100%' }}
					gridGap="32px"
					minHeight="309px"
					margin="0 auto"
					overflowX="scroll"
					overflow="auto"
					css={{
						'&::-webkit-scrollbar': {
							width: '0 !important',
						},
						//overflow: '-moz-scrollbars-none',
						//msOverflowStyle: 'none',
					}}
				>
					{useMemo(() => typeOptions[connectType](), [state, filteredGames])}
				</Flex>
			</Grid>
		</Flex>
	);
};
